import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IMobileNumber } from '@shared/models/numbers';

export class PhoneNumberValidator {
	/**
	 * Returns a ValidatorFn that checks if the phone number matches the selected country's dial code.
	 * This assumes the phone number object includes `e164Number` and `dialCode`.
	 */
	static matchDialCode(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value as IMobileNumber | null;

			if (!value || typeof value !== 'object') {
				return null;
			}

			const { e164Number, dialCode } = value;

			if (!e164Number || !dialCode) {
				return null;
			}

			if (!e164Number.startsWith(dialCode)) {
				return {
					misMatch: 'The selected country does not match the phone number input.',
				};
			}

			return null;
		};
	}
}
